<div class="info" title="">
    <i class="icon-info"></i>
    <ng-container *ngIf="!isHTML; else showMarkup">
        <div class="info-text">{{ infoText }}</div>
    </ng-container>
    <ng-template #showMarkup>
        <div class="info-text" [innerHTML]="infoText | keepHtml"></div>
    </ng-template>
</div>
